(() => {

  const STORAGE_KEY = 'barberMarketCompare';
  const MAX_PRODUCTS = 3;


  /* ======================================================
     GALERIA DE LA FICHA

     Dos cosas se rompian aca y las dos estan arregladas:

     1. Se buscaba la foto principal por [data-bm-product-main-image], y esa
        marca no existe en la pagina. El filtro image_tag de Shopify, que es el
        que arma la etiqueta <img>, no acepta atributos con guiones, asi que la
        marca nunca llego al HTML. Resultado: mainImage era null, la funcion se
        devolvia en la primera linea y las miniaturas quedaban sin ningun click
        asociado. Se veian, pero no hacian nada.

        Ahora, si la marca no esta, se busca por la clase de la foto. La marca
        se sigue aceptando primero por si algun dia vuelve.

     2. Aunque el click hubiera funcionado, tampoco se habria visto el cambio:
        la foto principal trae srcset (la lista de tamanos para cada pantalla) y
        el navegador le hace caso a srcset antes que a src. Cambiar solo src no
        cambia nada en pantalla. Por eso ahora se reescribe tambien el srcset,
        armado a partir de la misma direccion con los anchos de siempre.
     ====================================================== */

  const ANCHOS = [540, 720, 900, 1100, 1400];


  function srcsetDesde(src) {

    /* Las direcciones del CDN de Shopify terminan en ?v=...&width=1400.
       Cambiando ese numero se pide la misma foto en otro tamano. Si la
       direccion no trae width, se devuelve vacio y el srcset se retira: mejor
       una sola foto correcta que cinco direcciones inventadas. */

    if (!/[?&]width=\d+/.test(src)) {
      return '';
    }

    return ANCHOS
      .map((ancho) =>
        src.replace(/([?&]width=)\d+/, '$1' + ancho) + ' ' + ancho + 'w'
      )
      .join(', ');

  }


  function initializeGallery() {

    const mainImage =
      document.querySelector('[data-bm-product-main-image]') ||
      document.querySelector('.bm-product-gallery__main-image');

    if (!mainImage) {
      return;
    }

    const thumbs = document.querySelectorAll('[data-bm-product-thumb]');

    thumbs.forEach((button) => {

      if (button.dataset.bmBound === 'true') {
        return;
      }

      button.dataset.bmBound = 'true';

      button.addEventListener('click', () => {

        const src = button.dataset.imageSrc;

        if (!src) {
          return;
        }

        const srcset = button.dataset.imageSrcset || srcsetDesde(src);

        mainImage.src = src;

        if (srcset) {
          mainImage.setAttribute('srcset', srcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        document
          .querySelectorAll('[data-bm-product-thumb]')
          .forEach((thumb) => {
            thumb.classList.remove('is-active');
          });

        button.classList.add('is-active');

      });

    });

  }


  /* ======================================================
     COMPARE STORAGE
     ====================================================== */

  function getSelected() {

    try {

      const selected = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(selected)
        ? selected.filter(Boolean).slice(0, MAX_PRODUCTS)
        : [];

    } catch (error) {

      return [];

    }

  }


  function saveSelected(selected) {

    const clean = selected.filter(Boolean).slice(0, MAX_PRODUCTS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));

    window.dispatchEvent(
      new CustomEvent('bm:compare:change', {
        detail: {
          handles: clean
        }
      })
    );

  }


  /* ======================================================
     PRODUCT COMPARE
     ====================================================== */

  function updateCompareButton() {

    const button = document.querySelector('[data-bm-product-compare]');

    if (!button) {
      return;
    }

    const handle = button.dataset.productHandle;

    const selected = getSelected();

    const isSelected = selected.includes(handle);

    button.classList.toggle('is-selected', isSelected);

    button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

    const text = button.querySelector('[data-bm-product-compare-text]');

    if (text) {

      text.textContent = isSelected
        ? 'Añadido al Comparador Técnico'
        : 'Añadir al Comparador Técnico';

    }

  }


  function initializeCompare() {

    const button = document.querySelector('[data-bm-product-compare]');

    if (!button) {
      return;
    }

    if (button.dataset.bmBound === 'true') {

      updateCompareButton();
      return;

    }

    button.dataset.bmBound = 'true';

    button.addEventListener('click', () => {

      const handle = button.dataset.productHandle;

      if (!handle) {
        return;
      }

      const selected = getSelected();

      const index = selected.indexOf(handle);

      if (index !== -1) {

        selected.splice(index, 1);

        saveSelected(selected);

        updateCompareButton();

        return;
      }

      if (selected.length >= MAX_PRODUCTS) {

        alert('Puedes comparar un máximo de 3 productos.');

        return;
      }

      selected.push(handle);

      saveSelected(selected);

      updateCompareButton();

    });

    updateCompareButton();

  }


  /* ======================================================
     INITIALIZE
     ====================================================== */

  function initialize() {

    initializeGallery();

    initializeCompare();

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initialize);

  } else {

    initialize();

  }


  document.addEventListener('shopify:section:load', initialize);


  window.addEventListener('bm:compare:change', updateCompareButton);


  window.addEventListener('storage', (event) => {

    if (event.key === STORAGE_KEY) {

      updateCompareButton();

    }

  });

})();
